<template>
  <ContentContainer class="pb-20">
    <section
      class="grid grid-cols-1 gap-6 items-start md:gap-x-6 md:gap-y-0 md:grid-rows-[repeat(24,auto)]"
      :class="computedColumns"
    >
      <slot name="listItemBlock" />
    </section>
  </ContentContainer>
</template>

<script setup lang="ts">
import ContentContainer from '../../ContentContainer.vue';

const { getSlotItems } = useDrupalCe();
const listeItemBlocks = getSlotItems('listItemBlock');

const listeItems = computed(() => {
  return listeItemBlocks.value
    .map((vnode) => {
      const listItemBlock = vnode.props ?? null;
      return listItemBlock;
    })
    .filter((item) => item !== null);
});

const computedColumns = computed(() => {
  return `md:grid-cols-${listeItems.value.length}`;
});
</script>
